import axios from "axios";
import Constants from "../../../components.constants.js";
import Utils from "../../../components.utils.js"

export default {

    async createFolder(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.jobsUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[createFolder][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[createFolder][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async renameFolderOrFile(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.jobsUrl}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[renameFolderOrFile][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                // if (payload.params._id == context.state.loggedInUserInfo._id) {
                //     context.dispatch("updateLoggedInUserInfo", {})
                // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[renameFolderOrFile][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async triggerDownloadSupportBundleJob(context,notification) {
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if (notification.message.user_id == context.rootState.users.loggedInUserInfo._id){
            axios.get(`${Constants.extendedUrl}/${notification.message.download_url}`, {  responseType: 'blob' })
            .then(response => {
            const blob = new Blob([response.data], { type: 'application/zip' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = notification.message.path
            link.setAttribute('download', Utils.getBaseName(notification.message.bundle_path));
            link.click()
            URL.revokeObjectURL(link.href)
            console.log("---------------------", Utils.getBaseName(notification.message.bundle_path))
            Utils.setLocalStorageValue("supportbundle_localstorage_change", "Success")
            }).catch((error)=>{
                console.error(error)
                Utils.setLocalStorageValue("supportbundle_localstorage_change", "Failed")
            } )
        }
    },

    async getAboutInfo(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.versionInfoUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAboutInfo][Store][Error occured while getting version info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateReadStatusOfNewUpdates(context, payload = {}) {
        try {
          let resp = await axios.put(`${Constants.newUpdates}/${payload._id}`);
          if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateReadStatusOfNewUpdates][Store][Error occured while updating asset version info--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }else if (error.response.status == 405){
              return {statusCode:error.response.status,message:"failed to update asset version info"}
            } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },
};